
import axios from 'axios';
import rutas from '@/assets/utils/rutas.json';


const searchByQueryEstablecimiento = async ( search, establecimiento = null ) => {

  const query = `
    query MyQuery (
      $search : String! 
      $establecimiento : String
    ) {
      allCarteraAtencion(
        search: $search
        establecimiento: $establecimiento
      ) {
        message
        status
        total
        atenciones {
          codTarifa
          descripcion
          id
        }
      }
    }
  `;

  const variables = { search, establecimiento };

  try {
    const response = await axios.post(rutas.axios + "api", { query, variables });

    return response.data.data.allCarteraAtencion.atenciones.map((item) => ({
      value: item.id,
      text : `${item.codTarifa} - ${item.descripcion}`,
      cod  : item.codTarifa,
      descripcion: item.descripcion,
    }));

  } catch (error) {
    console.error("Error fetching atencionByQuery:", error);
    return null;
  }
}


export const carteraAtencionesService = {
  searchByQueryEstablecimiento 
}

